<template>
  <regular-bar :config="config">
    <current-base-filter></current-base-filter>
    <router-link class="button" :to="`/service-base/site-management/edit/${currentId}?step=site`">
      <v-icon>mdi-pencil-box-outline</v-icon>
    </router-link>
    <router-link class="button" to="/service-base/site-management/create?step=base">
      <v-icon>mdi-plus</v-icon>
    </router-link>
  </regular-bar>
</template>

<script>
import CurrentBaseFilter from './CurrentBaseFilter'
import RegularBar from './Regular'
export default {
  components: { RegularBar, CurrentBaseFilter },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      currentId: 1
    }
  }
}
</script>
